import Vue from "vue";
import VueRouter from "vue-router";
import $ from "jquery";
Vue.prototype.$ = $;
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/index",
  },
  {
    path: "/admin",
    name: "/admin",
    // redirect:"/twinScreenSystem",
    component: () => import("../pages/main.vue"),
    children: [
      {
        path: "/main",
        name: "main",
        component: () => import("../views/index.vue"),
      },
      {
        path: "/twinScreenSystem",
        name: "孪生大屏",
        // component: () => import("@/views/twinLargeScreen/twinScreenSystem.vue"),
        // component: () => import("@/views/twinLargeScreen/waterTwinScreen.vue"),
        component: () => import("@/views/twinLargeScreen/twinScreenBox.vue"),
      },
      {
        path: "/warehouse",
        name: "存货仓库",
        component: () => import("@/views/logistics/warehouse/index.vue"),
      },
      {
        path: "/inventorydetailsTable",
        name: "入库明细表",
        component: () =>
          import(
            "@/views/logistics/inventoryManage/inventorydetailsTable/index.vue"
          ),
      },
      {
        path: "/inventorySummaryTable",
        name: "入库汇总表",
        component: () =>
          import(
            "@/views/logistics/inventoryManage/inventorySummaryTable/index.vue"
          ),
      },
      {
        path: "/control",
        name: "control",
        component: () => import("../views/control.vue"),
      },
      {
        title: "角色管理",
        path: "/sysJsManage",
        name: "sysJsManage",
        component: () => import("../views/system/jsManage.vue"),
      },
      {
        title: "权限管理",
        path: "/sysJsPower",
        name: "sysJsPower",
        component: () => import("../views/system/jsPower.vue"),
      },
      {
        title: "系统操作日志",
        path: "/sysOptLog",
        name: "sysOptLog",
        component: () => import("../views/system/systemOptLog.vue"),
      },
      {
        title: "设备激活日志",
        path: "/sysDevLog",
        name: "sysDevLog",
        component: () => import("../views/system/systemDevLog.vue"),
      },
      {
        title: "出库明细表",
        path: "/ckdetailsTable",
        name: "ckdetailsTable",
        component: () => import("../views/system/ckdetailsTable.vue"),
      },
      {
        title: "出库汇总表",
        path: "/ckSummaryTable",
        name: "ckSummaryTable",
        component: () => import("../views/system/ckSummaryTable.vue"),
      },
      {
        title: "库存报表",
        path: "/kcdetailsTable",
        name: "kcdetailsTable",
        component: () => import("../views/system/kcdetailsTable.vue"),
      },
      {
        title: "库存盘点表",
        path: "/kcSummaryTable",
        name: "kcSummaryTable",
        component: () => import("../views/system/kcSummaryTable.vue"),
      },
      {
        title: "售后管理",
        path: "/shIndex",
        name: "shIndex",
        component: () => import("../views/system/shIndex.vue"),
      },
      {
        title: "售后详情",
        path: "/shDetail",
        name: "shDetail",
        component: () => import("../views/system/shDetail.vue"),
        meta: {
          fpath: "/shIndex",
        },
      },
      {
        title: "售后工单",
        path: "/shAdd",
        name: "shAdd",
        component: () => import("../views/system/shAdd.vue"),
        meta: {
          fpath: "/shIndex",
        },
      },
      {
        title: "工艺路线",
        path: "/processRoute",
        name: "processRoute",
        component: () => import("../views/craft/processRoute/index.vue"),
        // component: () => import("../views/procureManage/supplier/index.vue"),
        // component: () => import("../views/procureManage/procureOrder/index.vue"),
      },
      {
        title: "工艺工序",
        path: "/processProcessLog",
        name: "processProcessLog",
        component: () => import("../views/system/processProcessLog.vue"),
      },
      {
        title: "工艺工序",
        path: "/processProcessAdd",
        name: "processProcessAdd",
        component: () => import("../views/system/processProcessAdd.vue"),
        meta: {
          fpath: "/processProcessLog",
        },
      },
       {
        title: "生产工单",
        path: "/productionWorkOrder",
        name: "productionWorkOrder",
        component: () => import("../views/system/productionWorkOrder.vue"),
      },
      {
        title: "客户管理",
        path: "/customer",
        name: "customer",
        component: () => import("@/views/customerManagment/customer.vue"),
      },
      {
        title: "客户详情",
        path: "/customerDetail",
        name: "customerDetail",
        component: () => import("@/views/customerManagment/customerDetail.vue"),
      },
      {
        path: "/chci",
        name: "chci",
        component: {
          render: (h) => h("div"), // 空组件
          beforeRouteEnter(to, from, next) {
            window.open("http://chci.cn", "_blank");
            next(false); // 取消导航
          },
        },
      },
      {
        path: "/i369",
        name: "i369",
        component: {
          render: (h) => h("div"), // 空组件
          beforeRouteEnter(to, from, next) {
            window.open("https://cn.i369.com/", "_blank");
            next(false); // 取消导航
          },
        },
      },
      {
        path: "/dsp",
        name: "dsp",
        component: {
          render: (h) => h("div"), // 空组件
          beforeRouteEnter(to, from, next) {
            window.open("https://dsp.chci.cn/", "_blank");
            next(false); // 取消导航
          },
        },
      },
      {
        title: "请假管理",
        path: "/decision",
        name: "decision",
        component: () => import("@/views/decision/index.vue"),
      },
      {
        title: "外出管理",
        path: "/goOut",
        name: "dgoOutn",
        component: () => import("@/views/decision/goOut.vue"),
      },
      {
        title: "外出管理",
        path: "/overtime",
        name: "overtime",
        component: () => import("@/views/decision/overtime.vue"),
      },
      {
        title: "打卡补卡管理",
        path: "/punchcard",
        name: "punchcard",
        component: () => import("@/views/decision/punchcard.vue"),
      },
      {
        title: "自定义申请管理",
        path: "/userDefined",
        name: "userDefined",
        component: () => import("@/views/decision/userDefined.vue"),
      },
      {
        title: "调休时长管理",
        path: "/restTime",
        name: "restTime",
        component: () => import("@/views/decision/restTime.vue"),
      },
      {
        title: "年假管理",
        path: "/holiday",
        name: "holiday",
        component: () => import("@/views/decision/holiday.vue"),
      },
      {
        title: "行政体系管理",
        path: "/administration",
        name: "administration",
        component: () => import("@/views/decision/administration.vue"),
      },
      {
        title: "终端发布管理",
        path: "/adminChci",
        name: "adminChci",
        component: {
          render: (h) => h("div"), // 空组件
          beforeRouteEnter(to, from, next) {
            window.open("http://admin.chci.cn/admin/index.do", "_blank");
            next(false); // 取消导航
          },
        },
      },
      {
        title: "组织架构",
        path: "/organization",
        name: "organization",
        component: () => import("../views/organization/index.vue"),
      },
      {
        title: "考勤记录",
        path: "/attendanceRecord",
        name: "attendanceRecord",
        component: () => import("../views/attendance/attendanceRecord.vue"),
      },
      {
        title: "考勤设置",
        path: "/attendanceSetting",
        name: "attendanceSetting",
        component: () => import("../views/attendance/attendanceSetting.vue"),
      },
      {
        title: "考勤设备管理",
        path: "/attendanceDevice",
        name: "attendanceDevice",
        component: () => import("../views/attendance/attendanceDevice.vue"),
      },
      {
        title: "年假规则",
        path: "/annualRule",
        name: "annualRule",
        component: () => import("../views/attendance/annualRule.vue"),
      },

      {
        title: "企业简介",
        path: "/companyIntro",
        name: "companyIntro",
        component: () => import("../views/companyInfo/companyIntro.vue"),
      },
      {
        title: "企业制度",
        path: "/companyPolicy",
        name: "companyPolicy",
        component: () => import("../views/companyInfo/companyPolicy.vue"),
      },
      {
        title: "企业福利",
        path: "/companyWelfare",
        name: "companyWelfare",
        component: () => import("../views/companyInfo/companyWelfare.vue"),
      },
      {
        title: "企业制度电子签署",
        path: "/companyPolicySign",
        name: "companyPolicySign",
        component: () => import("../views/companyInfo/companyPolicySign.vue"),
      },
      {
        title: "岗位职责电子签署",
        path: "/positionDutySign",
        name: "positionDutySign",
        component: () => import("../views/companyInfo/positionDutySign.vue"),
      },
      {
        title: "进销存明细表",
        path: "/inventoryDetail",
        name: "inventoryDetail",
        component: () => import("../views/inventory/inventoryDetail.vue"),
      },
      {
        title: "进销存汇总表",
        path: "/inventorySummary",
        name: "inventorySummary",
        component: () => import("../views/inventory/inventorySummary.vue"),
      },
      {
        title: "生产车间",
        path: "/productionWorkshop",
        name: "productionWorkshop",
        component: () => import("../views/inventory/productionWorkshop.vue"),
      },
      {
        title: "商品类型",
        path: "/productType",
        name: "productType",
        component: () => import("../views/inventory/productType.vue"),
      },
      {
        title: "产品信息",
        path: "/productInfo",
        name: "productInfo",
        component: () => import("../views/inventory/productInfo.vue"),
      },
      {
        title: "存货仓库",
        path: "/inventoryWarehouse",
        name: "inventoryWarehouse",
        component: () => import("../views/inventory/inventoryWarehouse.vue"),
      },
      {
        title: "物料信息",
        path: "/materialInfo",
        name: "materialInfo",
        component: () => import("../views/inventory/materialInfo.vue"),
      },
      {
        title: "推广单位",
        path: "/promotionUnit",
        name: "promotionUnit",
        component: () => import("../views/inventory/promotionUnit.vue"),
      },
      // 产品溯源管理相关路由
      {
        title: "物料管理",
        path: "/material",
        name: "material",
        component: () => import("../views/purchaseSales/material.vue"),
      },
      {
        path: "/materhouse",
        name: "materhouse",
        component: () => import("../views/Warehousing/materhouse.vue"),
        meta: {
          fpath: "/material",
        },
      },
      // 物料出库
      {
        path: "/materOut",
        name: "materOut",
        component: () => import("../views/equipmentWarehouse/materOut.vue"),
        meta: {
          // noNeedCheckLogin: true,
          fpath: "/material",
        },
      },
      // {
      //   title: "库存管理",
      //   path: "/stock",
      //   name: "stock",
      //   component: () => import("../views/purchaseSales/stock.vue"),
      //   meta: {
      //     // noNeedCheckLogin: true,
      //   },
      // },
      {
        title: "库存查询",
        path: "/inventoryInquiry",
        name: "inventoryInquiry",
        component: () =>
          import("../views/purchaseSales/component/inventoryQuery.vue"),
      },
      {
        title: "产品管理",
        path: "/productManagement",
        name: "productManagement",
        component: () =>
          import("../views/purchaseSales/component/inventoryManagement.vue"),
      },
      {
        title: "出库产品线",
        path: "/outboundproductline",
        name: "outboundproductline",
        component: () =>
          import("../views/purchaseSales/component/outbound.vue"),
      },
      {
        title: "产品溯源管理",
        path: "/traceability",
        name: "traceability",
        component: () =>
          import("../views/purchaseSales/component/traceability.vue"),
      },
      {
        path: "/finished",
        name: "finished",
        component: () => import("../views/purchaseSales/finished.vue"),
        meta: {
          // noNeedCheckLogin: true,
          fpath: "/stock",
        },
      },
      //确认入库
      {
        path: "/firmGoods",
        name: "firmGoods",
        component: () => import("../views/purchaseSales/firmGoods.vue"),
        meta: {
          // noNeedCheckLogin: true,
          fpath: "/productManagement",
        },
      },
      // 成产品管理
      {
        path: "/finishedProduct",
        name: "finishedProduct",
        component: () => import("../views/versionsTwoPage/finishedProduct.vue"),
        meta: {
          fpath: "/productManagement",
        },
      },
      // 采购订单审核
      {
        path: "/purchaseOrderReview",
        name: "purchaseOrderReview",
        component: () => import("../views/versionsTwoPage/purchaseOrderReview.vue"),
        meta: {
          // fpath: "/productManagement",
        },
      },
      // 设备入库
      {
        path: "/warehousing",
        name: "warehousing",
        component: () => import("../views/Warehousing/index.vue"),
        meta: {
          fpath: "/productManagement",
        },
      },
      // 设备出库
      {
        path: "/outhousing",
        name: "outhousing",
        component: () => import("../views/equipmentWarehouse/index.vue"),
        meta: {
          fpath: "/productManagement",
        },
      },
      {
        title: "进销存明细表",
        path: "/stockDetail",
        name: "stockDetail",
        component: () => import("../views/inventory/inventoryDetail.vue"),
      },
      {
        title: "进销存汇总表",
        path: "/stockSummary",
        name: "stockSummary",
        component: () => import("../views/inventory/inventorySummary.vue"),
      },
      {
        title: "产品报价",
        path: "/productQuote",
        name: "productQuote",
        component: () => import("../views/reportTable/price.vue"),
      },
      {
        title: "设备配置",
        path: "/deviceConfiguration",
        name: "deviceConfiguration",
        component: () => import("../views/device/deviceConfiguration.vue"),
      },
      {
        title: "设备列表",
        path: "/deviceList",
        name: "deviceList",
        component: () => import("../views/device/index.vue"),
      },
       {
        title: "设备列表",
        path: "/deviceListcc",
        name: "deviceListcc",
        component: () => import("../views/device/com.vue"),
         meta: {
      isTwinLarge: true,
    },
      },
      {
        title: "生成订单",
        path: "/productionOrder",
        name: "productionOrder",
        component: () => import("../views/productionAdmin/productionOrder.vue"),
      },
      {
        title: "生产计划",
        path: "/productionPlan",
        name: "productionPlan",
        component: () => import("../views/productionAdmin/productionPlan.vue"),
      },
      {
        title: "供应商管理",
        path: "/supplierManage",
        name: "supplierManage",
         component: () => import("../views/procureManage/supplier/index.vue"),
      },
      {
        title: "采购订单",
        path: "/procureOrder",
        name: "procureOrder",
        component: () => import("../views/procureManage/procureOrder/index.vue"),
      },


    ],
  },
  {
    path: "/twinLargeScreen",
    name: "孪生大屏设置",
    component: () => import("@/views/twinLargeScreen/twinScreen.vue"),
    // component: () => import("@/views/twinLargeScreen/waterTwinScreen.vue"),
    children: [],
    meta: {
      isTwinLarge: true,
    },
  },

  {
    path: "/twinScreenCenter",
    name: "孪生大屏预览",
    component: () => import("@/views/twinLargeScreen/twinScreenCenter.vue"),
    children: [],
    meta: {
      isTwinLarge: true,
    },
  },
  {
    path: "/syIndex",
    name: "syIndex",
    component: () => import("../views/system/syIndex.vue"),
    meta: {
      isTwinLarge: true,
    },
  },
  {
    path: "/index",
    name: "systemIndex",
    component: () => import("../views/system/index.vue"),
    meta: {
      isTwinLarge: true,
    },
  },
  {
    path: "/noPermission",
    name: "noPermission",
    component: () => import("../pages/Unauthorized.vue"),
    meta: {
      fpath: "/noPermissionFpath",
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
